<template>
  <div class="TokenCompanyProfile">
    <div class="page_title">
      <el-divider>
        <div class="page_title_name">token平台</div>
      </el-divider>
    </div>
    <div class="page_content">
      <p class="page_content_text">QINGUE API 是面向合法授权场景的 AI API 网关与用量管理系统，为您的 AI 应用提供统一的基础设施，默认面向自用、团队内部和企业私有化部署。无缝集成全球主流 AI 服务提供商，包括 OpenAI、Anthropic、Google Gemini、DeepSeek、Midjourney、Suno 等 30+ 模型服务。</p>
      <el-button class="page_content_btn" @click="goToPlatform">进入平台</el-button>
      <img class="page_content_img" src="../../assets/qingye/token-platform-homepage.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TokenCompanyProfile",
  data() {
    return {
      platformUrl: "https://tokenhub.aobaai.com",
    };
  },
  methods: {
    goToPlatform() {
      window.open(this.platformUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.TokenCompanyProfile {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.page_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.page_title_name {
  font-weight: 600;
  font-size: 26px;
  text-align: center;
}
.page_content {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.page_content_text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2em;
}
.page_content_btn {
  align-self: center;
  margin-bottom: 20px;
  background-color: #2968BD;
  border-color: #2968BD;
  color: #fff;
  border-radius: 4px;
  padding: 12px 32px;
}
.page_content_btn:hover {
  background-color: #1e4f8f;
  border-color: #1e4f8f;
  color: #fff;
}
.page_content_img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Token/CompanyProfile.vue